export default __webpack_public_path__ + "static/Karla-Bold-b1c36eb43ddc47eea78d82716d7af15b.woff2";